module.exports = __webpack_public_path__ + "img/54.e2bf954d.png";